import { compareSection, Flow, flowMeta } from '../content/site';
import { Arrow } from './Icons';
import { Reveal } from './Reveal';
import './Compare.css';

type Props = {
  flow: Flow | null;
  onChoose: (flow: Flow) => void;
};

export function Compare({ flow, onChoose }: Props) {
  return (
    <section className="section section--cream" id="compare">
      <div className="container">
        <Reveal>
          <div className="section-head section-head--wide">
            <p className="eyebrow">{compareSection.eyebrow}</p>
            <h2 className="section-title">{compareSection.title}</h2>
            <p className="section-lead">{compareSection.lead}</p>
          </div>
        </Reveal>

        <Reveal>
          <div className="compare__scroll">
            <table
              className={`compare ${flow ? `is-highlight-${flow}` : ''}`}
            >
              <caption className="visually-hidden">
                A comparison of selling a will bank against selling a practice
              </caption>
              <thead>
                <tr>
                  <th scope="col" className="compare__corner">
                    <span className="visually-hidden">Point of comparison</span>
                  </th>
                  <th scope="col" className="compare__col compare__col--willbank">
                    Selling a will bank
                  </th>
                  <th scope="col" className="compare__col compare__col--practice">
                    Selling a practice
                  </th>
                </tr>
              </thead>
              <tbody>
                {compareSection.rows.map((row) => (
                  <tr key={row.label}>
                    <th scope="row" className="compare__label">
                      {row.label}
                    </th>
                    <td
                      className="compare__cell compare__cell--willbank"
                      data-col="Will bank"
                    >
                      {row.willbank}
                    </td>
                    <td
                      className="compare__cell compare__cell--practice"
                      data-col="Practice"
                    >
                      {row.practice}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Reveal>

        <Reveal>
          <div className="compare__ctas">
            {(['willbank', 'practice'] as Flow[]).map((option) => (
              <button
                key={option}
                type="button"
                className="compare__cta"
                onClick={() => onChoose(option)}
              >
                <span className="compare__cta-text">{flowMeta[option].cta}</span>
                <Arrow className="compare__cta-arrow" />
              </button>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
